import { Button, Card, Col, Result, Row, Select, Space, Switch, Typography } from 'antd';
import * as React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { waitForElm } from '../../utilites/htmlHelper';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import { RoleQueries } from '../../queries/roles-query';
import { CompanyQueries } from '../../queries/company-queries';
const { Title } = Typography;
const { Option } = Select;

function IndexManagementPage() {
  const roleList = RoleQueries.useRolesList();
  const [indexNow, setIndexNow] = useState<boolean>(true);
  const [companiesToIndex, setCompaniesToIndex] = useState<number[]>();
  const [entitiesToIndex, setEntitiesToIndex] = useState<number[]>();
  const [sectionsToIndex, setSectionsToIndex] = useState<number[]>();
  const companyIdQuery = CustomerServiceQueries.useGetActiveCompanyIds();
  const companyIndexMutator = CompanyQueries.usePostIndexAll();

  const entityIdQuery = CustomerServiceQueries.useGetValidSearchEntities();
  const entityIndexMutator = CompanyQueries.usePostIndexAllByEntity();

  const fileSectionIdQuery = CustomerServiceQueries.useGetValidSearchSectionTypes();
  const fileSectionIndexMutator = CompanyQueries.usePostIndexFilesBySectionType();

  React.useEffect(() => {
    const handleListPaste = (e) => {
      let splitDataString = e?.clipboardData?.getData("text").split(",");
      const companyIdsToPaste = splitDataString?.map(data => parseInt(data)) ?? [];
      setCompaniesToIndex(prevState => prevState != null && prevState.length > 0 ? [...prevState, ...companyIdsToPaste] : companyIdsToPaste);
      e.preventDefault();
    }

    const handleEntityListPaste = (e) => {
      let splitDataString = e?.clipboardData?.getData("text").split(",");
      const entityIdsToPaste = splitDataString?.map(data => parseInt(data)) ?? [];
      setEntitiesToIndex(prevState => prevState != null && prevState.length > 0 ? [...prevState, ...entityIdsToPaste] : entityIdsToPaste);
      e.preventDefault();
    }

    const handleSectionTypeListPaste = (e) => {
      let splitDataString = e?.clipboardData?.getData("text").split(",");
      const sectionIdsToPaste = splitDataString?.map(data => parseInt(data)) ?? [];
      setSectionsToIndex(prevState => prevState != null && prevState.length > 0 ? [...prevState, ...sectionIdsToPaste] : sectionIdsToPaste);
      e.preventDefault();
    }

    waitForElm("#companiesToIndex").then(() => {
      window.document?.getElementById("companiesToIndex")?.addEventListener("paste", handleListPaste);
    })

    waitForElm("#entityIdsToIndex").then(() => {
      window.document?.getElementById("entityIdsToIndex")?.addEventListener("paste", handleEntityListPaste);
    })

    waitForElm("#sectionIdsToIndex").then(() => {
      window.document?.getElementById("sectionIdsToIndex")?.addEventListener("paste", handleSectionTypeListPaste);
    })

    return () => {
      window.document?.getElementById("companiesToIndex")?.removeEventListener("paste", handleListPaste);
      window.document?.getElementById("entityIdsToIndex")?.removeEventListener("paste", handleEntityListPaste);
      window.document?.getElementById("sectionIdsToIndex")?.removeEventListener("paste", handleSectionTypeListPaste);
    };
  }, [])

  const handleCompanySubmit = () => {
    companyIndexMutator.mutateAsync({indexNow, companyIdList: companiesToIndex ?? [] }).then(() => {
      setCompaniesToIndex(undefined);
      setIndexNow(true);
    });
  }

  const handleEntitySubmit = () => {
    entityIndexMutator.mutateAsync(entitiesToIndex ?? []).then(() => {
      setEntitiesToIndex(undefined);
    });
  }

  const handleSectionTypeSubmit = () => {
    fileSectionIndexMutator.mutateAsync(sectionsToIndex ?? []).then(() => {
      setSectionsToIndex(undefined);
    });
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Title level={3}>Index Management Page</Title>
      </Col>
      {/* Restart Index by Entity Id */}
      <Col span={12}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Title level={5}>
                    Index By Content Type
                  </Title>
                </Col>
                <Col span={24}>
                  <Select
                    mode={'multiple'}
                    placeholder="Select Entities to Index"
                    className='full-width'
                    id="entityIdsToIndex"
                    value={entitiesToIndex}
                    onChange={val => setEntitiesToIndex(val)}
                    allowClear
                  >
                    {entityIdQuery.data?.sort((a, b) => a.id - b.id).map(entity => {
                      return (<Option value={entity.id} key={entity.id}>
                        {`${entity.name}`}
                      </Option>)
                    })}
                  </Select>
                </Col>
                <Col span={24}>
                  <Button type="primary" onClick={handleEntitySubmit} loading={entityIndexMutator.isLoading}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
          {/* Restart Index by File Section Type Id */}
          <Col span={24}>
            <Card>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Title level={5}>
                    Index Files By Section Type
                  </Title>
                </Col>
                <Col span={24}>
                  <Select
                    mode={'multiple'}
                    placeholder="Select Section Types to Index"
                    className='full-width'
                    id="sectionIdsToIndex"
                    value={sectionsToIndex}
                    onChange={val => setSectionsToIndex(val)}
                    allowClear
                  >
                    {fileSectionIdQuery?.data?.sort((a, b) => a.id - b.id).map(entity => {
                      return (<Option value={entity.id} key={entity.id}>
                        {`${entity.name.replace(/([A-Z])/g, ' $1').trim()}`}
                      </Option>)
                    })}
                  </Select>
                </Col>
                <Col span={24}>
                  <Button type="primary" onClick={handleSectionTypeSubmit} loading={fileSectionIndexMutator.isLoading}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Col>
      {/* Restart/Start Index by Compnay Id */}
      <Col span={12}>
        <Card>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Title level={5}>
                Index Specific companies
              </Title>
            </Col>
            <Col>
              <Space>
                <span>Start Index Now: </span>
                <Switch defaultChecked checkedChildren="Yes" unCheckedChildren="No" onClick={setIndexNow} checked={indexNow} />
              </Space>
            </Col>
            <Col span={24}>
              <Select
                mode={'multiple'}
                placeholder="Select Companies to Index"
                className='full-width'
                id="companiesToIndex"
                value={companiesToIndex}
                onChange={val => setCompaniesToIndex(val)}
                allowClear
              >
                {companyIdQuery.data?.map(company => {
                  return (<Option value={company.id} key={company.id}>
                    {`${company.id} - ${company.name}`}
                  </Option>)
                })}
              </Select>
            </Col>
            <Col span={24}>
              <Button type="primary" onClick={handleCompanySubmit} loading={companyIndexMutator.isLoading}>
                Submit
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}

export default IndexManagementPage;
